
import Vue from 'vue';
import Component from 'vue-class-component';
import BackgroundVideo from '@/components/BackgroundVideo.vue';
import SectionLayout from '@/components/SectionLayout.vue';
import NavBar from '@/components/NavBar/NavBar.vue';
import ForgotPassword from '@/components/Auth/Password/ForgotPassword.vue';
import SuccessCard from '@/components/Auth/SuccessCard.vue';
import ChangePassword from '@/components/Auth/Password/ChangePassword.vue';
import SignInDialog from '@/components/Auth/SignInDialog.vue';
import { authModule } from '@/utils/store-acessor';

@Component({
  components: {
    SignInDialog,
    ChangePassword,
    SuccessCard,
    ForgotPassword,
    NavBar,
    SectionLayout,
    BackgroundVideo
  }
})
export default class UpdatePasswordPage extends Vue {
  openDialog = false;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;

  changeSuccess(value: boolean) {
    this.$router.replace({ name: 'home' });
    // this.openDialog = value
  }

  onSuccessLoggedIn() {
    this.openDialog = false;
    this.$router.replace({ name: 'home' });
  }
}
